module.exports = __webpack_public_path__ + "media/images/front/about/miyazaki-462fd4d943c51fddd23aead1856a4ab6.jpg";